import { QuestionOption, Question } from '@longnecktech/splash-commons-fe';
import { QuestionStatus } from '@longnecktech/splash-commons-fe/dist/types/quiz/question';
import { ResultStatus } from '@shared/types/transaction-status';

export function isAnswerCorrectLegacy(
  questionOptions: QuestionOption[],
  pickedOptions: QuestionOption[][] | QuestionOption[],
  resultStatus?: ResultStatus,
): boolean {
  return questionOptions.some(
    (option) =>
      option.outcome === QuestionStatus.WON &&
      isOptionPickedLegacy(option.uuid, pickedOptions, resultStatus),
  );
}

export function isOptionPickedLegacy(
  optionUuid: string,
  pickedOptions: QuestionOption[][] | QuestionOption[],
  resultStatus?: ResultStatus,
): boolean {
  if (!pickedOptions) return false;
  return pickedOptions.some((dataItem) => {
    if (Array.isArray(dataItem)) {
      return dataItem.some((option) => {
        if (resultStatus && resultStatus !== ResultStatus.SUBMITTED) {
          return (
            option.uuid === optionUuid &&
            option.isPicked &&
            (option.outcome === QuestionStatus.WON ||
              option.outcome === QuestionStatus.PENDING ||
              option.outcome === QuestionStatus.VOIDED)
          );
        } else {
          return option.uuid === optionUuid && option.isPicked;
        }
      });
    } else {
      if (resultStatus && resultStatus !== ResultStatus.SUBMITTED) {
        return (
          dataItem.uuid === optionUuid &&
          dataItem.isPicked &&
          (dataItem.outcome === QuestionStatus.WON ||
            dataItem.outcome === QuestionStatus.PENDING ||
            dataItem.outcome === QuestionStatus.VOIDED)
        );
      }
      return dataItem.uuid === optionUuid && dataItem.isPicked;
    }
  });
}

export function isOptionWrongLegacy(
  optionUuid: string,
  pickedOptions: QuestionOption[][] | QuestionOption[],
  resultStatus?: ResultStatus,
): boolean {
  if (!resultStatus || resultStatus === ResultStatus.SUBMITTED) {
    return false;
  }
  return pickedOptions.some((dataItem) => {
    if (Array.isArray(dataItem)) {
      return dataItem.some(
        (option) =>
          option.uuid === optionUuid &&
          option.isPicked &&
          option.outcome === 'LOST',
      );
    } else {
      return (
        dataItem.uuid === optionUuid &&
        dataItem.isPicked &&
        dataItem.outcome === QuestionStatus.LOST
      );
    }
  });
}

export function isRealAnswerLegacy(
  optionUuid: string,
  questions: Question[],
  resultStatus?: ResultStatus,
): boolean {
  if (!questions || !resultStatus || resultStatus === ResultStatus.SUBMITTED) {
    return false;
  }
  return questions.some((question) => {
    return question.options.some((option) => {
      return (
        option.uuid === optionUuid && option.outcome === QuestionStatus.WON
      );
    });
  });
}

// NEW FUNCTIONS
//
export function isOptionWrong(
  option: QuestionOption,
  pickedUuid: string | null | undefined,
  resultStatus?: ResultStatus,
): boolean {
  if (!resultStatus || resultStatus === ResultStatus.SUBMITTED) {
    return false;
  }
  return pickedUuid === option.uuid && option.outcome === QuestionStatus.LOST;
}

export function isOptionCorrect(
  options: QuestionOption[],
  optionsUuid: string,
  resultStatus?: ResultStatus,
): boolean {
  if (!resultStatus || resultStatus === ResultStatus.SUBMITTED) {
    return false;
  }
  return options.some((option) => {
    return option.uuid === optionsUuid && option.outcome === QuestionStatus.WON;
  });
}

export function isOptionPicked(
  option: QuestionOption,
  pickedUuid: string | null | undefined,
  resultStatus?: ResultStatus,
): boolean {
  if (resultStatus && resultStatus !== ResultStatus.SUBMITTED) {
    return (
      option.uuid === pickedUuid &&
      (option.outcome === QuestionStatus.WON ||
        option.outcome === QuestionStatus.PENDING)
    );
  }
  return option.uuid === pickedUuid;
}

export function isAnswerCorrect(
  question: Question,
  pickedUuid: string | null | undefined,
  resultStatus?: ResultStatus,
): boolean {
  return question.options.some(
    (option) =>
      option.outcome === QuestionStatus.WON &&
      isOptionPicked(option, pickedUuid, resultStatus),
  );
}
